export interface Class3DIcon {
  id: string;
  name: string;
  path: string;
}

export const CLASS_3D_ICONS: Class3DIcon[] = [
  { id: 'cap', name: 'Mezuniyet Kepi', path: '/icons/cap.png' },
  { id: 'bag', name: 'Okul Çantası', path: '/icons/bag.png' },
  { id: 'book', name: 'Ders Kitapları', path: '/icons/book.png' },
  { id: 'trophy', name: 'Şampiyonluk Kupası', path: '/icons/trophy.png' },
  { id: 'rocket', name: 'Hızlı Kamp Roketi', path: '/icons/rocket.png' },
  { id: 'globe', name: 'Dünya & Coğrafya', path: '/icons/globe.png' },
  { id: 'microscope', name: 'Laboratuvar & Biyoloji', path: '/icons/microscope.png' },
  { id: 'atom', name: 'Fizik & Kimya', path: '/icons/atom.png' },
  { id: 'palette', name: 'Sanat & Tasarım', path: '/icons/palette.png' },
  { id: 'clock', name: 'Ders Saati & Zaman', path: '/icons/clock.png' },
  { id: 'bulb', name: 'Fikir & Buluş', path: '/icons/bulb.png' },
  { id: 'brain', name: 'Mantık & Zeka', path: '/icons/brain.png' },
  { id: 'crown', name: 'Derece & Taç', path: '/icons/crown.png' },
  { id: 'target', name: 'Sınav Hedefi', path: '/icons/target.png' },
];

export const CLASS_GRADIENTS = [
  'from-pink-500 via-rose-500 to-red-600',
  'from-teal-400 via-cyan-500 to-blue-600',
  'from-indigo-500 via-purple-500 to-pink-600',
  'from-amber-400 via-orange-500 to-red-500',
  'from-emerald-400 via-teal-500 to-cyan-600',
  'from-blue-500 via-indigo-500 to-violet-600',
];

/**
 * Sınıf ID'sine göre deterministik renk gradient'i üretir.
 * Hem öğretmen hem öğrencide ilgili sınıf için HER ZAMAN birebir aynı renk görüntülenir.
 */
export function getClassGradient(classIdOrName?: string | null): string {
  if (!classIdOrName) return CLASS_GRADIENTS[0];
  let hash = 0;
  for (let i = 0; i < classIdOrName.length; i++) {
    hash = (hash << 5) - hash + classIdOrName.charCodeAt(i);
    hash |= 0;
  }
  const index = Math.abs(hash) % CLASS_GRADIENTS.length;
  return CLASS_GRADIENTS[index];
}

/**
 * Sınıf nesnesinden veya tanımından aktif 3D ikon yolunu döner.
 * Eğer öğretmen bir ikon seçmediyse null döner.
 */
export function getClass3DIconPath(
  classItem?: { icon_key?: string | null; name?: string; description?: string } | string | null
): string | null {
  if (!classItem) return null;

  let iconKey: string | null = null;

  if (typeof classItem === 'string') {
    iconKey = classItem;
  } else {
    if (classItem.icon_key) {
      iconKey = classItem.icon_key;
    } else if (classItem.description && classItem.description.includes('[icon:')) {
      const match = classItem.description.match(/\[icon:([a-z0-9_-]+)\]/);
      if (match) iconKey = match[1];
    }
  }

  if (iconKey === 'none') return null;
  if (!iconKey) return null;

  const found = CLASS_3D_ICONS.find(i => i.id === iconKey);
  return found ? `${found.path}?v=2` : null;
}

/**
 * İkon anahtarını açıklama metnine gömmek için helper.
 */
export function encodeDescriptionWithIcon(description: string, iconKey: string | null): string {
  const cleanDesc = description.replace(/\[icon:[a-z0-9_-]+\]/gi, '').trim();
  if (!iconKey || iconKey === 'none') return cleanDesc;
  return cleanDesc ? `${cleanDesc} [icon:${iconKey}]` : `[icon:${iconKey}]`;
}

/**
 * Açıklama metninden ikon anahtarını ayıklar.
 */
export function extractIconFromDescription(description?: string | null): { cleanDesc: string; iconKey: string | null } {
  if (!description) return { cleanDesc: '', iconKey: null };
  const match = description.match(/\[icon:([a-z0-9_-]+)\]/);
  const iconKey = match ? match[1] : null;
  const cleanDesc = description.replace(/\[icon:[a-z0-9_-]+\]/gi, '').trim();
  return { cleanDesc, iconKey };
}

export function classInitials(name: string) {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase() ?? '')
    .join('');
}
